<template>
  <div v-if="isDev" class="bar-container">
    !!! Dev környezet !!!
  </div>
</template>

<script>
export default {
  name: "DevHeader",
  data() {
    return {
      hostname: window.location.hostname,
    };
  },
  computed: {
    isDev() {
      const tld = this.hostname.split('.').pop();
      return tld === 'localhost' || tld === 'dev';
    }
  }
};
</script>

<style scoped>
.bar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 14px;
  background-color: #2c3e50;
  background-image: repeating-linear-gradient(
      45deg,
      #f1c40f,
      #f1c40f 20px,
      #2c3e50 20px,
      #2c3e50 40px
  );
  background-size: 56px 56px;
  animation: slide 4s linear infinite;
  z-index: 99999;
  text-align: center;
  color: white;
  font-weight: 900;
  text-shadow: 0px 0px 2px black;
  text-transform: uppercase;
  font-size: 10px;
}

@keyframes slide {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 56px 0;
  }
}
</style>